import { Link } from 'gatsby'
import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

const Header = () => {
	
	function handleToggleMenu() {
		document.querySelector('.menu').classList.toggle('open');
		document.querySelector('.btnClose').style.display = 'block';
		// document.querySelector('.overlay').style.display = 'block';
		document.querySelector('body').style.overflow = 'hidden';
		document.querySelector('.btn-showmenu').classList.toggle('open');
	}

	function handleClosebtn() {
		document.querySelector('.menu').classList.remove('open');
		document.querySelector('.btnClose').style.display = 'none';
		// document.querySelector('.overlay').style.display = 'none';
		document.querySelector('body').style.overflow = 'visible';
		document.querySelector('.btn-showmenu').classList.toggle('open');
	}

	function handleScrollDisable() {
		document.querySelector('body').style.overflow = 'visible';
	}

	return (
		<div className="header">
			<Container>
				<div className="header-wrap">
					<button className="btn-showmenu" onClick={handleToggleMenu} onKeyDown={handleToggleMenu}>
						<img src="/app-icon-menu.svg" alt="app icon menu" />
					</button>
					<button className="btnClose" onClick={handleClosebtn} onKeyDown={handleClosebtn}>
						<img src="/app-icon-close.svg" alt="app icon down" />
					</button>
					{/* <div className="overlay" onClick={handleClosebtn} onKeyDown={handleClosebtn}></div> */}
					<div className="logo">
						<Link to="/" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
							<img src="/logo.svg" alt="Logo" />
						</Link>
					</div>
					<div className="menu">
						<ul className="menu-link">
							<li className="has-sub">
								<h6>
									Our Products
									<img className="app-icon-dot" src="/app-icon-dot.svg" alt="app icon dot" />
								</h6>
								<div className="sub">
									<Row className="app-multiple-row-custom-1">
										<Col xs={12} md={12} lg={4}>
											<div className="app-sub-child">
												<Link to="/products" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													Appvity eProduct Portfolio
													<h6>Build collaboration apps to connect everyone for your enterprise productivity.</h6>
												</Link>
											</div>
										</Col>
										<Col xs={12} md={12} lg={8}>
											<div className="app-sub-child">
												<Link to="/products/etask" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													<div className="app-sub-child-title">
														<img src="/app-icon-etask.svg" alt="app icon etask" />
														<img className="app-img-mobile-tablet" src="/app-icon-etask-mobile-tablet.svg" alt="app icon etask mobile tablet" />
														eTask
													</div>
													<h6>Manage your tasks from different data sources across organizations.</h6>
												</Link>
											</div>
											<div className="app-sub-child">
												<Link to="/products/ehelpdesk" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													<div className="app-sub-child-title">
														<img src="/app-icon-ehelpdesk.svg" alt="app icon ehelpdesk" />
														<img className="app-img-mobile-tablet" src="/app-icon-ehelpdesk-mobile-tablet.svg" alt="app icon ehelpdesk mobile tablet" />
														eHelpdesk
													</div>
													<h6>Easy to track every issue from your customers and boost your business' credibility.</h6>
												</Link>
											</div>
										</Col>
									</Row>
									<Row className="app-multiple-row-custom-2">
										<Col xs={12} md={12} lg={4}>
											<div className="app-sub-child">
												<Link to="/products/add-ins" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													Add-Ins
													<h6>Better working experience between eProducts and Microsoft apps.</h6>
												</Link>
											</div>
										</Col>
										<Col xs={12} md={12} lg={8}>
											<div className="app-sub-child">
												<Link to="/products/excel-sync" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													<div className="app-sub-child-title">
														<img src="/app-icon-excel-sync-header.svg" alt="app icon excel sync" />
														<img className="app-img-mobile-tablet" src="/app-icon-excel-sync-header-mobile-tablet.svg" alt="app icon excel sync mobile tablet" />
														Excel Sync
													</div>
													<h6>Synchronize items from eProducts and manage them in Microsoft Excel spreadsheet.</h6>
												</Link>
											</div>
											<div className="app-sub-child">
												<Link to="/products/outlook" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													<div className="app-sub-child-title">
														<img src="/app-icon-outlook.svg" alt="app icon outlook" />
														<img className="app-img-mobile-tablet" src="/app-icon-outlook-mobile-tablet.svg" alt="app icon outlook mobile tablet" />
														Outlook
													</div>
													<h6>Synchronize items from eProducts and manage them in Microsoft Excel spreadsheet.</h6>
												</Link>
											</div>
										</Col>
									</Row>
								</div>
							</li>
							<li className="has-sub">
								<h6>
									Our Services
									<img className="app-icon-dot" src="/app-icon-dot.svg" alt="app icon dot" />
								</h6>
								<div className="sub">
									<Row className="app-single-row-custom">
										<Col xs={12} md={12} lg={4}>
											<div className="app-sub-child">
												<Link to="/services" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													Service Overview
													<h6>Focus on the simplest ways to solve existing business problems.</h6>
												</Link>
											</div>
										</Col>
										<Col xs={12} md={12} lg={8}>
											<div className="app-sub-child">
												<Link to="/services/software-development" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													Software Development Service
													<h6>Help build your custom SharePoint applications on time and within budget.</h6>
												</Link>
											</div>
											<div className="app-sub-child">
												<Link to="/services/solution" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													Solution Service
													<h6>Customize our defined solutions to fit your enterprise demand.</h6>
												</Link>
											</div>
										</Col>
									</Row>
								</div>
							</li>
							<li className="has-sub">
								<h6>
									Support
									<img className="app-icon-dot" src="/app-icon-dot.svg" alt="app icon dot" />
								</h6>
								<div className="sub">
									<Row className="app-single-row-custom">
										<Col xs={12} md={12} lg={4}>
											<div className="app-sub-child">
												<Link to="/support" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													Support Center
													<h6>It's a place to assist you in time for any queries.</h6>
												</Link>
											</div>
										</Col>
										<Col xs={12} md={12} lg={8}>
											<div className="app-sub-child">
												<a href="/OnlineDoc">
													Online Docs
													<h6>Provide user guide, application notes, and technical related documents.</h6>
												</a>
											</div>
											<div className="app-sub-child">
												<Link to="/support/blogs" onClick={handleScrollDisable} onKeyDown={handleScrollDisable}>
													Blogs
													<h6>We share our experience related to applications and Microsoft technologies.</h6>
												</Link>
											</div>
										</Col>
									</Row>
								</div>
							</li>
						</ul>
						{/* <div className="app-login-signup">
							<Link to="/" className="app-login">Login</Link>
							<Link to="/" className="app-signup">
								<span className="app-signup-text">You don’t have an account yet.</span>
								<span>Signup</span>
							</Link>
						</div> */}
					</div>
					{/* <div className="app-online-store">
						<h6>
							<a href="https://300u26337848130.3dcartstores.com/" className="app-login">Go to Store 
								<img src="/app-icon-go-to-store.svg" alt="app icon go to store" />
							</a>
						</h6>
					</div> */}
				</div>
			</Container>
		</div>
	)
}
export default Header